(() => {
  const drawer = document.querySelector('#ch-cart');
  if (!drawer) return;
  const strings = JSON.parse(document.querySelector('#ch-cart-strings').textContent);
  const root = drawer.dataset.root.replace(/\/?$/, '/');
  const status = drawer.querySelector('[data-ch-cart-status]');
  const items = drawer.querySelector('[data-ch-cart-items]');
  const bottom = drawer.querySelector('.ch-cart-bottom');
  let busy = false;
  let opener;
  let currency = 'USD';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency}).format(cents / 100);
  const element = (tag, text, className) => {
    const el = document.createElement(tag);
    if (text !== undefined) el.textContent = text;
    if (className) el.className = className;
    return el;
  };
  const request = async (path, payload) => {
    const response = await fetch(root + path, payload === undefined ? {headers: {Accept: 'application/json'}} : {
      method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(payload)
    });
    const result = await response.json();
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : strings.error);
    return result;
  };
  const setBusy = value => {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-ch-change],button[name="checkout"]').forEach(button => { button.disabled = value; });
  };
  const draw = cart => {
    currency = cart.currency || 'USD';
    document.querySelectorAll('[data-ch-count]').forEach(count => {
      count.textContent = String(cart.item_count);
      count.hidden = cart.item_count === 0;
    });
    const incentive = drawer.querySelector('[data-ch-shipping-progress]');
    if (incentive) {
      const eligible = cart.items.filter(item => String(item.product_id) === '15405334298925').reduce((sum, item) => sum + item.quantity, 0);
      incentive.querySelector('p').textContent = eligible >= 2 ? '✓ Two sets reached. Free standard shipping applies to eligible U.S. deliveries.' : eligible === 1 ? 'Add one more CORE HOME set to unlock free U.S. standard shipping.' : 'Free U.S. standard shipping when you purchase 2 or more eligible sets.';
      incentive.querySelector('progress').value = Math.min(eligible, 2);
    }
    items.replaceChildren();
    for (const item of cart.items) {
      const row = element('article', undefined, 'ch-cart-item');
      const image = element('img');
      if (item.image) {
        const url = new URL(item.image, location.origin);
        if (url.protocol === 'https:') { url.searchParams.set('width', '170'); image.src = url.href; }
      }
      image.alt = item.product_title;
      image.width = 85;
      image.height = 100;
      row.append(image);
      const info = element('div');
      info.append(element('h3', item.product_title));
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(element('p', item.variant_title));
      info.append(element('p', money(item.final_line_price)));
      const quantity = element('div', undefined, 'ch-quantity');
      const changeButton = (label, text, quantityValue) => {
        const button = element('button', text);
        button.type = 'button';
        button.setAttribute('aria-label', label + ': ' + item.product_title);
        button.dataset.chChange = item.key;
        button.addEventListener('click', () => change(item.key, quantityValue));
        return button;
      };
      quantity.append(changeButton(strings.decrease, '−', item.quantity - 1));
      const amount = element('output', String(item.quantity));
      amount.setAttribute('aria-label', strings.quantity);
      quantity.append(amount, changeButton(strings.increase, '+', item.quantity + 1));
      const remove = changeButton(strings.remove, strings.remove, 0);
      remove.className = 'ch-remove';
      info.append(quantity, remove);
      row.append(info);
      items.append(row);
    }
    bottom.hidden = cart.item_count === 0;
    drawer.querySelector('[data-ch-total]').textContent = money(cart.total_price);
    status.textContent = cart.item_count === 0 ? strings.empty : '';
  };
  const refresh = async () => draw(await request('cart.js'));
  const open = trigger => {
    opener = trigger;
    if (!drawer.open) drawer.showModal();
  };
  const close = () => { drawer.close(); opener?.focus(); };
  const change = async (id, quantity) => {
    if (busy) return;
    setBusy(true);
    try {
      const cart = await request('cart/change.js', {id, quantity});
      draw(cart);
      setBusy(false);
      drawer.querySelector('[data-ch-change]')?.focus();
    } catch (error) { status.textContent = error.message || strings.error; }
    finally { setBusy(false); }
  };
  document.querySelectorAll('[data-ch-cart-open]').forEach(trigger => trigger.addEventListener('click', async () => {
    open(trigger);
    if (busy) return;
    setBusy(true);
    status.textContent = strings.loading;
    try { await refresh(); }
    catch { status.textContent = strings.error; bottom.hidden = true; }
    finally { setBusy(false); }
  }));
  drawer.querySelectorAll('[data-ch-close]').forEach(button => button.addEventListener('click', close));
  drawer.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const rect = drawer.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right) close();
  });
  document.querySelectorAll('[data-ch-buy]').forEach(form => form.addEventListener('submit', async event => {
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const id = new FormData(form).get('id');
    if (busy || button.disabled || !id) return;
    const formStatus = form.querySelector('[role="status"]');
    formStatus.textContent = '';
    setBusy(true);
    button.disabled = true;
    let added = false;
    try {
      await request('cart/add.js', {items: [{id: Number(id), quantity: 1}]});
      added = true;
      open(button);
      await refresh();
      status.textContent = strings.added;
      formStatus.textContent = strings.added;
    } catch (error) {
      formStatus.textContent = added ? strings.refresh_error : error.message || strings.error;
      if (added) { status.textContent = strings.refresh_error; bottom.hidden = true; }
    } finally { setBusy(false); button.disabled = false; }
  }));
  refresh().catch(() => {});
})();

const coreAnnouncement = document.querySelector("[data-ch-announcement]");
if (coreAnnouncement) {
  let manuallyPaused = false;
  const pauseButton = coreAnnouncement.querySelector("[data-ch-promo-pause]");
  const update = () => coreAnnouncement.toggleAttribute("data-paused", document.hidden || manuallyPaused);
  pauseButton?.addEventListener("click", () => {
    manuallyPaused = !manuallyPaused;
    pauseButton.setAttribute("aria-pressed", String(manuallyPaused));
    pauseButton.setAttribute("aria-label", manuallyPaused ? pauseButton.dataset.playLabel : pauseButton.dataset.pauseLabel);
    pauseButton.textContent = manuallyPaused ? "▶" : "Ⅱ";
    update();
  });
  document.addEventListener("visibilitychange", update);
  update();
}

